import { render, staticRenderFns } from "./DetailAnswer.vue?vue&type=template&id=ff6735ae&scoped=true"
import script from "./DetailAnswer.vue?vue&type=script&lang=js"
export * from "./DetailAnswer.vue?vue&type=script&lang=js"
import style0 from "./DetailAnswer.vue?vue&type=style&index=0&id=ff6735ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6735ae",
  null
  
)

export default component.exports